/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 24.07.13, 10:22
 *
 * $URL$
 * $Rev$
 * $Author$
 * $Date$
 * $Id$
 */


export class BasicRequiredRegistrationFieldsVO {
    public username: string;
    public email: string;
    public password: string;

    constructor(username: string, email: string, password: string) {
        this.username = username;
        this.email = email;
        this.password = password;
    }
}
